module.exports = __webpack_public_path__ + "static/media/SolidSnake.69bf7a63.jpg";